import { render, staticRenderFns } from "./MagicChildrenBlock.vue?vue&type=template&id=0885dc0e&scoped=true"
import script from "./MagicChildrenBlock.vue?vue&type=script&lang=ts"
export * from "./MagicChildrenBlock.vue?vue&type=script&lang=ts"
import style0 from "./MagicChildrenBlock.vue?vue&type=style&index=0&id=0885dc0e&prod&lang=scss&scoped=true"
import style1 from "./MagicChildrenBlock.vue?vue&type=style&index=1&id=0885dc0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885dc0e",
  null
  
)

export default component.exports